const COMPONENT_NAME = "emailsignupform--all";
const ICON_WIDTH_HEIGHT = "20px";
const MEMBERSHIP_NUMBER_FIELD_LENGTH = 12;
export {
  COMPONENT_NAME,
  ICON_WIDTH_HEIGHT,
  MEMBERSHIP_NUMBER_FIELD_LENGTH
};
